import createEnum from 'lib/createEnum';

export const LOCATIONS = createEnum('HOME', 'ANSWER', 'CHAT', 'OFFICE_HOURS');
export const STAGES = createEnum(
  'CHAT',
  'CHAT_CLOSED',
  'CHAT_THROTTLED',
  'ONBOARDING',
  'DEMO_SELF_SERVICE',
  'SELF_SERVICE'
);

export default {
  LOCATIONS,
  STAGES,
};
